<div class="notification-item-box border-dark br-2 px-pt-5 px-pr-10 px-pb-10 px-pl-15">
    <div class="notification-item-top  d-flex flex-row justify-content-between align-items-baseline fs-14px">
        <span class="notification-item-status text-capitalize">
    {{ data?.status }}
  </span>
        <div class="notification-item-top-right px-pt-5 d-flex flex-row justify-content-end align-items-center">
            <div class="notification-item-date" [class.d-none]="withinPopup">{{ data?.notifDate | date:'hh:mm dd MMM' }}</div>
            <div class="notification-item-close cursor-pointer px-w-14 px-h-14 px-ml-3" (click)="doClose()"></div>
        </div>
    </div>

    <div class="notification-item-core fs-12px">
        {{ data?.message }}
    </div>

    <div class="notification-item-bottom d-flex flex-row justify-content-between align-items-end fs-12px">
        <div>{{ data?.creatorID }}</div>
        <div *ngIf="data?.isVisible" class="notification-item-view text-right text-uppercase cursor-pointer pt-0 px-px-4 px-pb-2 br-2 user-select-none" (click)="doView()">
            VIEW
        </div>
    </div>
</div>